export enum ImportTypes {
  import = "IMPORT",
  upload = "UPLOAD",
}

export enum FileTypes {
  OCR = "OCR",
  LINDOFF = "Lindoff",
}